import React from 'react'
import { Link, useHistory } from "react-router-dom"
import {
  Row,
  Col,
  Form,
  Input,
  Button,
  // Checkbox
} from 'antd'
import { LockOutlined } from '@ant-design/icons'
import { useAuth } from '../../contexts/AuthContext'

const ResetPass = () => {
  const { updatePass } = useAuth()
  const history = useHistory()

  const onFinish = (values) => {
    updatePass(values.password)
      .then(user => {
        history.push("/")
      })
    console.log('Success:', values)
  }

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo)
  }

  return (
    <Row justify="center">
      <Col span={24} lg={{ span: 7 }}>
        <div className="form-container">
          <div className="form-header">
            <h1>Create New Password</h1>
            {/* <p>Update your account password</p> */}
          </div>
          <Form
            name="reset_pass"
            size="large"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Password is reuired!' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                type="password"
                placeholder="Password"
              />
            </Form.Item>
            <Form.Item
              name="confirm"
              dependencies={['password']}
              // hasFeedback
              rules={[
                {
                  required: true,
                  message: 'Please confirm your password!',
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve()
                    }
                    return Promise.reject(new Error('Password and Confirm passwords does not match!'))
                  },
                }),
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                type="password"
                placeholder="Confirm Password"
              />
            </Form.Item>
            <Form.Item className="mt-2">
              <Button type="primary" htmlType="submit" size="large" className="px-4">
                Reset Password
              </Button>
              <span className="form-link-right ant-btn-lg">
                <Link to="/auth/login">Go Back to Log In</Link>
              </span>
            </Form.Item>
          </Form>
        </div>
      </Col>
    </Row>
  )
}

export default ResetPass
